import { useState } from "react";
import PermissionGate from "../layout/PermissionGate";

const APIKey = ({ item, setRegenerate, setBranchId }) => {
  const [hidden, setHidden] = useState(true);
  const [copied, setCopied] = useState(false);

  return (
    <tr className="text-center">
      <td>{item?.name ?? ""}</td>
      <td>
        {item?.apiKey && hidden === false ? item?.apiKey : "*".repeat(74)}
      </td>
      <td className="text-center">
        <div className="d-flex justify-content-center gap-2">
          <button
            className="btn btn-sm btn-light text-center"
            title={`${hidden ? "Show" : "Hide"}`}
            onClick={() => {
              setHidden((prev) => !prev);
            }}
          >
            <i
              className={`bi-duotone ms-1 bi-${hidden ? "eye" : "eye-slash"}`}
            ></i>
          </button>
          <PermissionGate
            required={`regenerate_merchant_api_keys`}
            fallback={<></>}
          >
            <button
              className="btn btn-sm btn-light text-center"
              title="Regenerate"
              onClick={() => {
                setRegenerate((prev) => !prev);
                setBranchId(item?._id);
              }}
            >
              <i className={`bi-duotone ms-1 bi-arrow-repeat`}></i>
            </button>
          </PermissionGate>
          <button
            onClick={async () => {
              await navigator.clipboard.writeText(item?.apiKey ?? "");
              setCopied(true);
              setTimeout(() => setCopied(false), 2000);
            }}
            className="btn btn-sm btn-light text-center"
            title={`${copied ? "Copied" : "Copy"}`}
          >
            <i
              className={`bi-duotone ms-1 bi-${
                copied === false ? "copy" : "clipboard-check-fill"
              }`}
            ></i>
          </button>
        </div>
      </td>
    </tr>
  );
};

export default APIKey;
